import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import Swal from "sweetalert2"; // optional for confirmation popup

@Component({
  selector: 'app-ask-book',
  templateUrl: './ask-book.component.html',
  styleUrls: ['./ask-book.component.scss'],
      encapsulation: ViewEncapsulation.None

})
export class AskBookComponent implements OnInit {
  public arrCoupons: any[] = [];
  maincategoryDetails: any;
  lang: string;

  constructor(
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private loading: LoadingService,
    private toastr: ToastrService,
    private modal: NgbModal,
private translate: TranslateService,
    private router: Router, 
    private language : LanguageService
  ) {}

  public currentPage = 1;
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

  public levels: any[] = [];
  public tempData = [];

  // SubCatgories Data
  public categories: any;

  
  /**
   *
   * Variables for Editing Sub Categories
   *
   */
  public mainCategories: any;
  public subCategoryName: any;
  public mainCategoryId: any;
  public subCategoryId: any;
  
  /**
   *
   * End of Variables
   *
   */
  
  public isEmpty : boolean = false
  

  @ViewChild(DatatableComponent) table: DatatableComponent;

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe(data => this.lang = data)
    this.getReports();
  }

 getReports(callback?: () => void) {
  this.loading.show();

  this.apisService.getaskBooks(this.currentPage).subscribe((res: any) => {
    this.loading.hide();

    if (res.data.length === 0) {
      this.isEmpty = true;
      this.categories = [];
    } else {
      this.categories = res.data;
      this.totalItems = this.categories.length;
    }

    if (callback) callback(); // ✅ Call success alert here if provided
  });
}

confirmDelete(id: number): void {
  this.translate.get([
    'MENU.DASHBOARD.TITLE',
    'MENU.DASHBOARD.TEXT',
    'MENU.DASHBOARD.CONFIRM',
    'MENU.DASHBOARD.CANCEL',
    'DELETE_SUCCESS.TITLE',
    'DELETE_SUCCESS.TEXT',
    'MENU.DASHBOARD.OK'
  ]).subscribe(translations => {
    Swal.fire({
      title: translations['MENU.DASHBOARD.TITLE'],
      text: translations['MENU.DASHBOARD.TEXT'],
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: translations['MENU.DASHBOARD.CANCEL'],
      confirmButtonText: translations['MENU.DASHBOARD.CONFIRM'],
    }).then((result) => {
      if (result.isConfirmed) {
        this.apisService.deleteSubCategories(id).subscribe({
          next: () => {
            // Only reload data here — don't show success yet
            this.getReports(() => {
              // ✅ Show success alert AFTER data is refreshed
              Swal.fire({
                title: translations['MENU.DASHBOARD.TITLE'],
                text: translations['MENU.DASHBOARD.DELETED_TITLE'],
                icon: 'success',
                confirmButtonText: translations['MENU.DASHBOARD.OK']
              });
            });
          },
          error: () => {
            Swal.fire({
              title: translations['MENU.DASHBOARD.TITLE'],
              text: translations['MENU.DASHBOARD.DELETED_TITLE'],
              icon: 'error',
              confirmButtonText: translations['MENU.DASHBOARD.OK']
            });
          },
        });
      }
    });
  });
}


  // example reload method
  loadBooks(): void {
    // your logic to refresh the table
  }

  /*----------  Main Category  ----------*/
mainCategory(row?: any) {
  this.loading.show();

  this.apisService.getMainCategories(this.currentPage).subscribe({
    next: (res) => {
      this.mainCategories = this.mainCategories ? [...this.mainCategories, ...res.data] : res.data;

      
      if (res.data.length === 10) {
        this.currentPage++;
        this.mainCategory(row); 
      } else {
        this.loading.hide();

        
        if (row) {
          this.mainCategoryId = row.categoryId;
        } else if (this.maincategoryDetails) {
          this.mainCategoryId = this.maincategoryDetails.id;
        }
      }
    },
    error: (err) => {
      console.log("error in fetching", err);
      this.loading.hide();
    },
  });
}



  /*----------  Edit SubCategory  ----------*/
  editSubCategory(): void {
    this.apisService
      .editSubCategory(
        this.subCategoryId,
        this.subCategoryName,
        this.mainCategoryId
      )
      .subscribe({
        next: (res) => {
          this.getReports();
          this.toastr.success("SubCategory updated successfully", "Success");
          this.modal.dismissAll();
        },
        error: (err) => {
          console.log("error in fetching", err);
          this.toastr.error("Something went wrong", "Error");
        },
      });
  }

  /*=============================================
=            Modal Functions            =
=============================================*/
openModal(content: any, row?: any) {
  if (row) {
    this.maincategoryDetails = row;
    this.mainCategory(this.maincategoryDetails);
    this.subCategoryId = row.id;
    this.subCategoryName = row.subCategoryName;
  }

  const modalRef = this.modal.open(content, { centered: true, size: 'md' });

  // Reload the page AFTER the modal is closed or dismissed
  modalRef.closed.subscribe(() => {
    window.location.reload(); // ✅ Reloads the entire page
  });

  modalRef.dismissed.subscribe(() => {
    window.location.reload(); // ✅ Reloads if modal is dismissed (optional)
  });

  // ❌ Don't reload here
  // this.getSubCategories();
}


  close() {
    this.modal.dismissAll();
  }

  /*=====  End of Modal Functions  ======*/

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }



/*----------  Pagination Functions   ----------*/
next(){ 
  this.currentPage++
  this.getReports()
}

prev(){ 
  this.currentPage--
  this.getReports()
}

sendNotification(row: any): void {
  const payload = {
    user_id: row.user_id || row.id,
    title: 'New Notification',
    body: 'You have a new message'
  };

  if (!payload.user_id) {
    console.error('user_id is missing', row);
    return;
  }

  this.apisService.SendNotifications(payload).subscribe({
    next: (res) => {
      console.log('Notification sent', res);
    },
    error: (err) => {
      console.error('Send notification error', err);
    }
  });
}



}
